/**
 * Ensures a URL has a protocol (http:// or https://).
 * If no protocol is present, prepends https://
 * 
 * @param url - The URL to check and potentially fix
 * @returns The URL with a protocol, or the original value if it's falsy
 * 
 * @example
 * ensureProtocol('example.com') // returns 'https://example.com'
 * ensureProtocol('https://example.com') // returns 'https://example.com'
 * ensureProtocol('http://example.com') // returns 'http://example.com'
 * ensureProtocol(null) // returns null
 * ensureProtocol('') // returns ''
 */
export function ensureProtocol(url: string | null | undefined): string | null | undefined {
  if (!url || typeof url !== 'string') {
    return url;
  }

  // Check if the URL already has a protocol
  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  // Prepend https:// if no protocol is present
  return `https://${url}`;
}
